import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Spinner } from 'react-bootstrap';
import './loader.css'

const Loading = ({ height }) => {



    return (
        <>
            <div  className='divLoader'>
                <Spinner animation="border" role="status"  variant='primary'  >
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>

        </>

    )
}

export default Loading;